import axios, { AxiosRequestConfig } from 'axios';
import { AvailabilityStatus, DataResponse } from '../types';

const URL = '/v2/sitter-availability-status';

class AvailabilityStatusService {
  static get(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AvailabilityStatus>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static create(
    data: AvailabilityStatus,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AvailabilityStatus>> {
    return axios.post(URL, data, config);
  }

  static patch(
    id: number,
    data: AvailabilityStatus,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AvailabilityStatus>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { AvailabilityStatusService };
